export * from './lib/icon.data';
